export default {
  label: 'Keskustele tiimimme kanssa',
  label_unread: 'Keskustele tiimimme kanssa, {{count}} uutta',
};
